import { useRef } from 'react';

const useAudioEffects = () => {
  const audioCtxRef = useRef(null);

  const getAudio = () => {
    if (!audioCtxRef.current) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      audioCtxRef.current = new Ctx();
    }
    return audioCtxRef.current;
  };

  const tone = (freq = 440, duration = 0.08, type = 'sine', gain = 0.04) => {
    const ctx = getAudio();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});

    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gainNode.gain.value = gain;

    osc.connect(gainNode);
    gainNode.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  };

  const sfxPop = () => tone(560, 0.05, 'triangle', 0.03);
  const sfxLose = () => tone(320, 0.06, 'sine', 0.025);

  const sfxWin = () => {
    tone(660, 0.08, 'triangle', 0.04);
    setTimeout(() => tone(880, 0.1, 'triangle', 0.04), 90);
  };

  const sfxEnd = () => {
    tone(220, 0.12, 'sawtooth', 0.03);
    setTimeout(() => tone(180, 0.18, 'sawtooth', 0.03), 120);
  };

  return { sfxPop, sfxLose, sfxWin, sfxEnd };
};

export default useAudioEffects;
